module.exports = __webpack_public_path__ + "img/forensicEvidence.4991886e.png";